import React, { useEffect } from "react";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import SEOHead from "../components/common/SEOHead";
import Socials from "../components/about/socials";

import SEO from "../data/seo";

import "./styles/contact.css";

const Contact = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "contact");

	return (
		<React.Fragment>
			<SEOHead
				title="Contact"
				description={currentSEO.description}
				keywords={currentSEO.keywords}
				path="/contact"
				jsonLd={[
					{
						"@context": "https://schema.org",
						"@type": "ContactPage",
						"@id": "https://www.northwestwind.org/contact#contact",
						url: "https://www.northwestwind.org/contact",
						name: "Contact North West Wind",
						description: currentSEO.description,
						mainEntity: { "@id": "https://www.northwestwind.org/#person" },
					},
				]}
			/>

			<div className="page-content">
				<NavBar active="contact" />
				<div className="content-wrapper">
					<div className="contact-logo-container">
						<div className="contact-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="contact-container">
						<div className="title contact-title">
							Let's Get in Touch!
						</div>

						<div className="subtitle contact-subtitle">
						If you would like to discuss digital products, software development, partnerships, or potential collaborations, feel free to get in touch.
						</div>
					</div>

					<div className="socials-container">
						<div className="contact-socials">
							<Socials />
						</div>
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Contact;
